export default __webpack_public_path__ + "images/7e566f50-information.svg";